/**
 * @callback OnConnectionStateChangeCallback
 * @param {ConnectionService.CONNECTION_SERVICE_STATE}
 */

class ConnectionService {
  constructor() {
    this.registeredCallbacks = [];
    this.registerConnectionStateChange();
  }

  /**
   * @param {OnConnectionStateChangeCallback} onConnectionStateChangeCallback
   */
  onConnectionStateChange(onConnectionStateChangeCallback) {
    this.registeredCallbacks.push(onConnectionStateChangeCallback);
  }

  /**
   * @private
   */
  registerConnectionStateChange() {
    window.addEventListener('online', () => {
      this.triggerRegisteredCallbacks(ConnectionService.CONNECTION_SERVICE_STATE.ONLINE);
    });

    window.addEventListener('offline', () => {
      this.triggerRegisteredCallbacks(ConnectionService.CONNECTION_SERVICE_STATE.OFFLINE);
    });
  }

  /**
   * @param {ConnectionService.CONNECTION_SERVICE_STATE} state
   * @private
   */
  triggerRegisteredCallbacks(state) {
    this.registeredCallbacks.forEach(function (registeredCallback) {
      registeredCallback(state);
    });
  }
}

/**
 * @readonly
 * @enum {Number}
 */
ConnectionService.CONNECTION_SERVICE_STATE = {
  ONLINE: 0,
  OFFLINE: 1,
};

export default ConnectionService;
